import { fb } from '../../copyFeatBrowse'
import type { Card } from '../../lib/browse'
import type { AskState } from '../../lib/askBrowse'
import { buttonClass } from '../../ui/styles'
import { Spinner } from '../../ui/Spinner'
import { ListingCard } from './ListingCard'
import { photoRow } from './Photo'
import { Grid } from './Rails'
import { BrowseMap } from './BrowseMap'
import type { ReactNode } from 'react'

/** R-05: the answer to their ask, in place of the rows and the full list; Clear brings Browse back. */
export function AskResults({ ask, cards, onClear, showDistance, map, toggle }: { ask: AskState; cards: Card[]; onClear: () => void; showDistance: boolean; map: boolean; toggle: ReactNode }) {
  const busy = ask.status === 'asking'
  return (
    <section data-review-id="ask-results" aria-labelledby="ask-title" aria-busy={busy || undefined} className="mt-6 lg:mt-12">
      <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
        <div className="min-w-0">
          <p className="t-eyebrow text-ink-2">{fb('fb.ask.eyebrow')}</p>
          <h2 id="ask-title" data-sentry-mask className="t-section mt-1 break-words">{ask.status === 'done' ? ask.understood : ask.q}</h2>
        </div>
        <div className="flex items-center gap-2">
          {toggle}
          <button type="button" data-review-id="ask-clear" aria-label={fb('fb.ask.clear_label')} onClick={onClear} className={buttonClass('secondary', 'md', 'shrink-0 px-4')}>{fb('fb.ask.clear')}</button>
        </div>
      </div>
      {busy && <p role="status" className="t-meta mt-3 flex items-center gap-2 text-ink-2"><Spinner size={16} label={false} className="text-current" />{fb('fb.ask.loading')}</p>}
      {ask.status === 'error' && <p role="alert" className="t-meta mt-3 text-error">{ask.error === 'limit' ? fb('fb.ask.limit') : fb('fb.ask.error')}</p>}
      {ask.status === 'done' && ask.loose && cards.length > 0 && <p className="t-meta mt-3 text-ink-2">{fb('fb.ask.loose')}</p>}
      {ask.status === 'done' && cards.length === 0 && (
        <div className="mt-4 border border-line bg-surface p-5"><p className="t-body text-ink">{fb('fb.ask.empty')}</p></div>
      )}
      {cards.length > 0 && (
        <div className={`mt-4 transition-opacity ${busy ? 'opacity-55' : ''}`}>
          {map ? <BrowseMap cards={cards} more={false} /> : (
            <Grid>{cards.map((c, i) => <ListingCard key={c.item.id} card={c} showDistance={showDistance} photo={photoRow(cards)} row="ask" position={i} />)}</Grid>
          )}
        </div>
      )}
    </section>
  )
}
